import valueFilters from '../valueFilters';
import modelFactory from '../modelFactory';

const STATUS = {
	pending: 'pending',
	queued: 'queued',
	progressing: 'progressing',
	complete: 'complete',
	failed: 'failed'
} as const;

type FileUploadStatus = keyof typeof STATUS;

export interface IFileUploadState {
	readonly status: FileUploadStatus,
	readonly progress?: number;
	readonly url?: string;
}

const fileUploadStateFactory = Object.assign(modelFactory.createFactory<IFileUploadState>('FileUploadState', {
	status: {
		writable: false,
		defaultValue: STATUS.pending
	},
	progress: {
		writable: false,
		setFilters: valueFilters.toNumber
	},
	url: {
		writable: false,
		setFilters: valueFilters.clean
	}
}), {
	STATUS
})

export default fileUploadStateFactory;